import { FrameList } from 'components/pages/AvailabilityReport/AddFilter/AddFilter.types';

export const calculateTotalFrameCount = (selectedFrameList?: FrameList): number => {
  if (!selectedFrameList) return 0;

  const manualFramesCount = selectedFrameList.routeFrameCodes?.length ?? 0;
  const uploadedFramesCount =
    selectedFrameList.uploadedFrameLists?.reduce((total, file) => {
      if (file.include === false) return total;

      const totalFrames = file.fileContents?.length ?? 0;
      const excludedFrames = file.excludedFrameCodes?.length ?? 0;

      return total + (totalFrames - excludedFrames);
    }, 0) ?? 0;

  return manualFramesCount + uploadedFramesCount;
};
